const CERTIFICATION_PATTERNS = [
    {
        pattern: /\b(?:certified\s+)?gluten[\s-]?free\b/i,
        name: 'Gluten-Free Certified',
        description: 'Product is certified to contain less than 20ppm gluten',
        safetyContext: 'Safe for celiac disease and gluten sensitivity, but check for cross-contact warnings',
    },
    {
        pattern: /\bnut[\s-]?free\b/i,
        name: 'Nut-Free Certified',
        description: 'Product is certified free from tree nuts and peanuts',
        safetyContext: 'Safe for tree nut and peanut allergies when properly certified',
    },
    {
        pattern: /\bdairy[\s-]?free\b/i,
        name: 'Dairy-Free Certified',
        description: 'Product is certified to contain no dairy ingredients',
        safetyContext: 'Safe for milk allergy; verify no cross-contact with dairy equipment',
    },
    {
        pattern: /\begg[\s-]?free\b/i,
        name: 'Egg-Free Certified',
        description: 'Product is certified to contain no egg ingredients',
        safetyContext: 'Safe for egg allergy; check for cross-contact',
    },
    {
        pattern: /\bsoy[\s-]?free\b/i,
        name: 'Soy-Free Certified',
        description: 'Product is certified to contain no soy ingredients',
        safetyContext: 'Safe for soy allergy; check for hidden soy derivatives',
    },
    {
        pattern: /\bvegan\b/i,
        name: 'Vegan Certified',
        description: 'Product contains no animal-derived ingredients',
        safetyContext: 'Implies no milk, eggs, fish, shellfish, but may contain trace allergens',
    },
    {
        pattern: /\borganic\b/i,
        name: 'Organic Certified',
        description: 'Product meets organic farming standards',
        safetyContext: 'Organic does NOT mean allergen-free; allergens can still be present',
    },
    {
        pattern: /\bnon[\s-]?gmo(?:\s+project\s+verified)?\b/i,
        name: 'Non-GMO Verified',
        description: 'Product does not contain genetically modified organisms',
        safetyContext: 'Non-GMO status does not relate to allergen safety',
    },
    {
        pattern: /\bhalal\b/i,
        name: 'Halal Certified',
        description: 'Product meets Islamic dietary requirements',
        safetyContext: 'May reduce certain cross-contact risks but does not guarantee allergen-free',
    },
    {
        pattern: /\bkosher\b/i,
        name: 'Kosher Certified',
        description: 'Product meets Jewish dietary requirements',
        safetyContext: 'Kosher Pareve indicates no dairy/meat; does not guarantee allergen-free',
    },
    {
        pattern: /\ballergen[\s-]?free\b/i,
        name: 'Allergen-Free Claim',
        description: 'Product claims to be free from specific allergens',
        safetyContext: 'Verify which specific allergens are excluded — "allergen-free" is not standardized',
    },
    {
        pattern: /\btop\s+8\s+(?:allergen[\s-]?)?free\b/i,
        name: 'Top-8 Allergen Free',
        description: 'Product claims free from the 8 major US allergens',
        safetyContext: 'May still contain EU-specific allergens (celery, lupin, mollusks, mustard, sesame)',
    },
    {
        pattern: /\btop\s+14\s+(?:allergen[\s-]?)?free\b/i,
        name: 'Top-14 Allergen Free',
        description: 'Product claims free from the 14 EU allergens',
        safetyContext: 'Most comprehensive allergen-free claim available',
    },
    {
        pattern: /\bpeanut[\s-]?free\b/i,
        name: 'Peanut-Free',
        description: 'Product is labeled peanut-free',
        safetyContext: 'Safe for peanut allergy; check for tree nut cross-contact',
    },
    {
        pattern: /\bsesame[\s-]?free\b/i,
        name: 'Sesame-Free',
        description: 'Product is labeled sesame-free',
        safetyContext: 'Sesame became the 9th major US allergen in 2023',
    },
];
// Curated glossary derived from the pattern set — exported for reference
// resources so the MCP server can publish authoritative safety context.
export const certificationGlossary = CERTIFICATION_PATTERNS.map((p) => ({
    name: p.name,
    description: p.description,
    safetyContext: p.safetyContext,
}));
let counter = 0;
export function detectCertifications(text) {
    const matches = [];
    for (const cert of CERTIFICATION_PATTERNS) {
        const match = text.match(cert.pattern);
        if (match) {
            matches.push({
                id: `cert-${counter++}`,
                name: cert.name,
                description: cert.description,
                safetyContext: cert.safetyContext,
            });
        }
    }
    return matches;
}
//# sourceMappingURL=certificationEngine.js.map